module.exports = "/images/expand.svg?ea736464edb4824884ae3d8dce0414a1";